<script>
import { getCountry } from "@/api/system";
const planType = [
  {
    displayName: "Distribution",
    value: 0
  },
  {
    displayName: "Promotion",
    value: 1
  },
  {
    displayName: "Sales Fundamental",
    value: 2
  },
  {
    displayName: "Media",
    value: 3
  },
  {
    displayName: "BOT-ROI",
    value: 4
  },
  {
    displayName: "BOT-DTC POME",
    value: 5
  },
  {
    displayName: "Pricing Sizing",
    value: 6
  },
  {
    displayName: "Ecommerce",
    value: 7
  }
];
const fileStatus = [
  {
    displayName: "In Progress",
    value: 0
  },
  {
    displayName: "Completed",
    value: 1
  },
  {
    displayName: "Failed",
    value: 2
  }
];
const tabs = [
  {
    title: "Distribution"
  },
  {
    title: "Promotion"
  },
  {
    title: "Sales Fundamental"
  },
  {
    title: "Media"
  },
  {
    title: "BOT-ROI"
  },
  {
    title: "NOS per SU"
  },
  {
    title: "Pricing Sizing"
  },
  {
    title: "Ecommerce"
  }
];
const userStatus = [
  {
    displayName: "Inactive",
    value: 0
  },
  {
    displayName: "Active",
    value: 1
  }
];
const planStatus = [
  {
    displayName: "Draft",
    role: "ABM",
    value: 0
  },
  {
    displayName: "Pending MP Review",
    role: "MP",
    value: 1
  },
  {
    displayName: "Pending Commercial Inputs",
    role: "ABM",
    value: 2
  },
  {
    displayName: "Pending DP Validation",
    role: "DP",
    value: 3
  },
  {
    displayName: "Pending MP LoadDecision",
    role: "MP",
    value: 4
  },
  {
    displayName: "Completed",
    role: "MP",
    value: 5
  }
];
const commonHeader = [
  {
    headerName: "Category *",
    field: "category",
    cellEditor: "autoComplete",
    headerClass: "required blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "Brand",
    field: "brand",
    cellEditor: "autoComplete",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "Subbrand",
    field: "subbrand",
    cellEditor: "autoComplete",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "Form",
    field: "form",
    cellEditor: "autoComplete",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "Variant",
    field: "variant",
    cellEditor: "autoComplete",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "Size",
    field: "size",
    cellEditor: "autoComplete",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "GTIN(IT)",
    field: "gtin",
    cellEditor: "numeric",
    headerClass: "blue",
    headerComponent: "customHeader",
  },
  {
    headerName: "SKU GCAS",
    field: "sku",
    cellEditor: "gcas",
    headerClass: "blue",
    headerComponent: "customHeader",
  }
];
const customerHeader = [
  {
    headerName: "Channel / Customer",
    field: "channelCustomer",
    cellEditor: "autoComplete",
    headerClass: "blue"
  },
  {
    headerName: "Sub-Channel",
    field: "subChannel",
    headerClass: "blue"
  },
  {
    headerName: "Region  *",
    field: "region",
    headerClass: "required blue"
  }
];
const loadDecision = ["BOP", "R&O", "Assessment Only"];
const runrateSource = ["Shipment", "Sellout_MR", "Sellout_DO"];
const runrateDuration = ["P3M", "P6M", "P9M", "P12M"];
const trafficInputType = [
  "Investment/Month",
  "Impression/Month",
  "Traffic/Month"
];
const benchMarkActivity = [
  "Distribution",
  "Promotion",
  "Sales Fundamental",
  "Media",
  "BOT-ROI",
  "NOS Per SU",
  "Pricing Sizing",
  "Ecommerce-KR"
];
const ctrEffectiveness = [" ", "Normal", "High"];

const pipelineType = ["Pipe (One-Time)", "Pipe (Monthly phasing)"];
const validationTypeDistri = ["Offtake Uplift", "PPD"];
const validationTypePro = [
  "With Fixed Cover",
  "Without Fixed Cover",
  "Lotsell Promo"
];
const baseAPI = `${process.env.BASE_DEV_API}/api/MasterData/`;
const uploadLink = {
  factBook: `${baseAPI}Factbook`,
  granularity: `${baseAPI}Granularity`,
  mapping: `${baseAPI}CCMapping`,
  sellout: `${baseAPI}Sellout`,
  shipment: `${baseAPI}TdReport`
};
const sideBar = {
  toolPanels: [
    {
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivots: true,
        suppressPivotMode: true,
        suppressSideButtons: true,
        suppressColumnSelectAll: true,
        suppressColumnExpandAll: true
      }
    }
  ],
  defaultToolPanel: "columns"
};
const validationType = [
  "Index to Fair Share (SOD/ SoSh)",
  "Sensitivity Coeff (SOD/ SoSh)",
  "Factor of Runrate",
  "Factor of Pipeline",
  "Index to Fair Share (SOD/ SoSh) - by No. of Doors"
];

const pricingCurrency = ["PHP", "IDR", "THB", "MYR", "SGD", "VND", "KRW"];
const sizingUOM = ["ML", "L", "GM", "KG", "COUNT"];

export default {
  planType,
  fileStatus,
  tabs,
  userStatus,
  planStatus,
  commonHeader,
  loadDecision,
  runrateSource,
  runrateDuration,
  trafficInputType,
  ctrEffectiveness,
  benchMarkActivity,
  customerHeader,
  pipelineType,
  validationTypeDistri,
  validationTypePro,
  uploadLink,
  sideBar,
  validationType,
  pricingCurrency,
  sizingUOM
};
</script>



// WEBPACK FOOTER //
// src/Global.vue